<template>
  <div>
    <div class="flex m-t-30">
      <div class="flex-column w-120 m-h-20" v-if="!bindType || bindType=== 1">
        <img src="../../../assets/erp/ic_jst.png" class="h-50" alt="" style="width: 100%">
        <el-button class="m-t-10" type="primary" v-if="!bindType" @click="onBindClick(1)">绑定聚水潭
        </el-button>
        <div class="m-t-10" v-if="bindType=== 1">已绑定</div>
      </div>
      <div class="flex-column w-120 m-h-20" style="position: relative" :class="{bindClass:bindType=== 2}"
           v-if="!bindType || bindType=== 2">
        <div class="h-50 w-full">
          <img src="../../../assets/erp/ic_wdt.png" class="h-50" alt="" style="width: 100%">
        </div>
        <el-button class="m-t-10" type="primary" v-if="!bindType" @click="onBindClick(2)">绑定旺店通
        </el-button>
        <div class="m-t-10" v-if="bindType=== 2">已绑定</div>
        <!--        <div class="w-full h-full bindItem" style="position: absolute;top:0;left:0;background: #00000080">-->
        <!--          <div class="w-full h-full flex a-center j-center fs-20 text-white bold" @click.stop="onProductAsync"-->
        <!--               style="cursor: pointer">-->
        <!--            同步商品-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <!--      <div class="flex-column w-120 m-h-20" v-if="!bindType || bindType=== 3">-->
      <!--        <img src="../../../assets/erp/ic_kd.png" class="h-50" alt="" style="width: 100%">-->
      <!--        <el-button class="m-t-10" type="primary" v-if="!bindType" @click="onBindClick(3)">绑定快递100</el-button>-->
      <!--        <div class="m-t-10" v-if="bindType=== 3">已绑定</div>-->
      <!--      </div>-->
    </div>

    <el-dialog title="绑定设置" append-to-body :visible.sync="dialogVisible" @close="dialogFormVisible"
               :close-on-click-modal="false" :close-on-press-escape="false" width="800px">
      <el-form size="small" :model="form" ref="order">
        <div>
          <el-form-item label="sid" prop="sid" v-if="form.platType === 2" :rules="[{required: true,message: ' '}]">
            <el-input placeholder="sid" v-model="form.sid">
            </el-input>
          </el-form-item>
          <el-form-item label="应用appKey" prop="appKey" :rules="[{required: true,message: ' '}]">
            <el-input placeholder="应用appKey" v-model="form.appKey">
            </el-input>
          </el-form-item>
          <el-form-item label="应用appSecret" prop="appSercret" :rules="[{required: true,message: ' '}]">
            <el-input placeholder="应用appSecret" v-model="form.appSercret">
            </el-input>
          </el-form-item>
          <el-form-item label="应用店铺Id" prop="outSupplierId" :rules="[{required: true,message: ' '}]">
            <el-input placeholder="应用店铺Id" v-model="form.outSupplierId">
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <!--内容-->
      <div slot="footer" class="dialog-footer d-b-c">
        <div class="setlink-footer-btn">
          <el-button size="small" @click="dialogFormVisible(false)">取 消</el-button>
          <el-button size="small" type="primary" @click="dialogFormVisible(true)">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import SettingApi from '@/api/setting.js'

export default {
  name: 'index',
  data () {
    return {
      dialogVisible: false,
      bindType: '',
      form: {
        platType: '',
        sid: '',
        appKey: '',
        appSercret: '',
        outSupplierId: ''
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      this.getShopBindAccount()
    },
    onBindClick (platType) {
      this.form = {
        platType: platType,
        sid: '',
        appKey: '',
        appSercret: '',
        outSupplierShopId: ''
      }
      this.dialogVisible = true
    },
    dialogFormVisible (visibleStatus) {
      if (visibleStatus) {
        this.$refs.order.validate((valid) => {
          if (valid) {
            let params = this.form
            SettingApi.setBindAccount(params, true).then(data => {
              this.getShopBindAccount()
              this.dialogVisible = false
            })
          }
        })
      } else {
        this.dialogVisible = false
      }
    },
    getShopBindAccount () {
      let params = {}
      SettingApi.getBindAccount(params, true).then(data => {
        this.form = data.data
        this.bindType = data.data.platType || ''
      })
    },
    onProductAsync () {
      let params = {}
      SettingApi.asyncProductToWDT(params, true).then(data => {
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bindItem {
  display: none;
}

.bindClass:hover {
  .bindItem {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/setting/erp/index.vue